import {BACKEND} from '../../consts/backend';

const GetTypes = async () => {
  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };

  const resp = await fetch(
    `${BACKEND}/operationtypes`,
    requestOptions
  );
  const sku = await resp.json();

  return sku;
};

export default GetTypes;
